import { MenuItem, MenuItemText, useTheme } from '@mint/ui';
import React, { useCallback, useContext, useMemo } from 'react';
import { AdminTableActionButtonContext } from '../admin-table-action-button';
import { AdminTableActionButtonItemProps } from './admin-table-action-button-item-props';

export const AdminTableActionButtonItem: React.FunctionComponent<
  AdminTableActionButtonItemProps
> = props => {
  const { color, onClick, ...rest } = props;
  const { close } = useContext(AdminTableActionButtonContext);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      if (onClick) {
        onClick(e);
      }
      if (!e.isDefaultPrevented()) {
        close();
      }
    },
    [onClick, close],
  );

  const theme = useTheme();

  const style = useMemo(
    () => ({
      color: color === 'danger' ? theme.palette.error.dark : undefined,
    }),
    [color],
  );

  return (
    <MenuItem onClick={handleClick} {...rest}>
      <MenuItemText style={style}>{props.children}</MenuItemText>
    </MenuItem>
  );
};
